import WithRender from "../../templates/containers/quantityContainer.html";
import { mapActions, mapGetters } from "vuex";
import constants from "../../helpers/constants";

function quantity_debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export default WithRender({
  computed: {
    ...mapGetters(["getQuantities", "getHasGrossPrice", "getPriceDisplayType"]),
    getColHeaders: function () {
      let headers = ["Quantity"];
      const priceDisplayType = this.getPriceDisplayType;
      if (
        constants.TAX_DISPLAY_TYPE_EXCL_TAX == priceDisplayType ||
        constants.TAX_DISPLAY_TYPE_BOTH == priceDisplayType
      ) {
        headers.push("Net");
      }
      if (
        constants.TAX_DISPLAY_TYPE_INCL_TAX == priceDisplayType ||
        constants.TAX_DISPLAY_TYPE_BOTH == priceDisplayType
      ) {
        headers.push("Gross");
      }
      return headers;
    }
  },

  methods: {
    ...mapActions(["setQuantity", "setPageOption"]),
    setQuantityDebounce: quantity_debounce(function (qty, qtyCode) {
      this.setQuantity({ qty, qtyCode });
    }, 500),
    activeClass: active => {
      return active ? "active" : "";
    },
    canDisplayNetPrice: function () {
      return (
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_EXCL_TAX ||
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_BOTH
      );
    },
    canDisplayGrossPrice: function () {
      return (
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_INCL_TAX ||
        this.getPriceDisplayType == constants.TAX_DISPLAY_TYPE_BOTH
      );
    }
  },
  props: ["hideContainer"]
});
